import { Box } from '@mui/material';

interface PegProps {
  x: number;
  y: number;
  size?: number;
}

export const Peg = ({ x, y, size = 20 }: PegProps) => {
  return (
    <Box
      component="img"
      src="/bubble.png" // ✅ koristi / jer je u public folderu
      sx={{
        position: 'absolute',
        left: x - size / 2,
        top: y - size / 0.2, // ⬅ centriramo peg oko x,y
        width: size,
        height: size,
        pointerEvents: 'none',
        zIndex: 2,
      }}
    />
  );
};
